export default "https://cdn-static.gokick.com/assets/34e3985c60c1a4021cd40bb2eb2cab3e4962f61f/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";